import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { Grid } from 'style';
import { Media, Spacer200 } from '..';
import ExternalVideoMediaComponent from '../media/media.externalvideo.component';

const LargeImageVideoComponent = ({
    image,
    video,
    loop,
    backgroundColor,
    backgroundImage,
    textColor,
    imageBackgroundColor,
    showFullscreenControl,
    showMuteControl,
    alignLeft,
    alignCenter,
    alignRight,
}) => (
    <LargeImageVideoWrapper
        backgroundImage={backgroundImage && backgroundImage.url}
        id="LargeImageVideoComponent">
        <Grid.Wrapper
            backgroundColor={
                !backgroundImage && backgroundColor && backgroundColor.hex
            }
            textColor={textColor && textColor.hex}>
            {backgroundImage && backgroundImage.url && <Spacer200 />}
            <Grid.Overflow>
            <div className="wrapper">
                <div className="container-fluid">
                        <ImageContainer
                            alignLeft={alignLeft}
                            alignCenter={alignCenter}
                            alignRight={alignRight}>
                            {(image || video) && (
                                <Media
                                    backgroundColor={
                                        imageBackgroundColor &&
                                        imageBackgroundColor.hex
                                    }
                                    video={video}
                                    image={image}
                                    loop={loop}
                                    showFullscreenControl={
                                        showFullscreenControl
                                    }
                                    showMuteControl={showMuteControl}
                                />
                            )}
                        </ImageContainer>
                </div>
                </div>
            </Grid.Overflow>
            {backgroundImage && backgroundImage.url && <Spacer200 />}
        </Grid.Wrapper>
    </LargeImageVideoWrapper>
);

const LargeImageVideoWrapper = styled.div`
    background-image: ${props =>
        props.backgroundImage ? `url(${props.backgroundImage});` : ''};
    background-size: cover;
    background-position: center;
`;

const imageAlignment = (alignLeft, alignRight) => {
    if (alignLeft == true) {
        return css`
            margin: 0 auto 0 0;
        `;
    }
    if (alignRight == true) {
        return css`
            margin: 0 0 0 auto;
        `;
    }
    return css`
        margin: 0 auto;
    `;
};

const ImageContainer = styled.div`
    font-size: 0;

    ${props => imageAlignment(props.alignLeft, props.alignRight)};
    img {
        max-width: 100%;
    }

    width: 100%;
`;

export default LargeImageVideoComponent;
